import { useCallback, useSyncExternalStore } from "react";
import { useDataStoreClient } from "./provider";

/** Reactively returns whether a collection has active consumers */
export function useHasConsumers(name: string): boolean {
  const client = useDataStoreClient();

  const subscribe = useCallback((onStoreChange: () => void) => client.subscribeConsumers(onStoreChange), [client]);
  const getSnapshot = useCallback(() => client.getConsumerSnapshot(), [client]);

  useSyncExternalStore(subscribe, getSnapshot);

  return client.hasConsumers(name);
}
